import { EditScreen } from '../features/account/EditScreen'

export function ProfileEditPage() {
  return <EditScreen />
}
